<form
  class="choose-row"
  [ngClass]="styleClass"
  [formGroup]="form"
>
  <app-select
    [title]="title"
    [formControlNameString]="fieldName"
    [choicesMap]="timeRange"
    [sortingMethod]="sortingMethod"
  ></app-select>
</form>
